import {
  CcfBox,
  CcfNoRequestFoundIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { CcfWemTable } from './ccf-wem-table';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface CcfWemScheduleRequestesProps {}

/**
 * CcfWemScheduleRequestes - used to display wem schedule requests
 * @param props - CcfWemScheduleRequestes
 * @example `<CcfWemScheduleRequestes />`
 */
export function CcfWemCcfWemScheduleRequestes(
  props: CcfWemScheduleRequestesProps
) {
  const shiftTradeTypeColumns = [
    {
      field: 'requestedDate',
      headerName: 'REQUESTED DATE',
      width: 180,
      flex: 1,
    },
    {
      field: 'requestedTime',
      headerName: 'REQUESTED TIME',
      width: 170,
      flex: 1,
    },
    {
      field: 'requestType',
      headerName: 'REQUEST TYPE',
      width: 180,
      flex: 1,
    },
    {
      field: 'requestedon',
      headerName: 'REQUESTED ON',
      width: 200,
      flex: 1,
    },
    {
      field: 'tradewith',
      headerName: 'TRADE WITH',
      width: 200,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'STATUS',
      width: 150,
      flex: 1,
    },
    {
      field: 'reviewdby',
      headerName: 'REVIEWED BY',
      width: 150,
      flex: 1,
    },
  ];

  const activityTypeColumns = [
    {
      field: 'requestedDates',
      headerName: 'REQUESTED DATES',
      width: 180,
      flex: 1,
    },
    {
      field: 'requestedTime',
      headerName: 'REQUESTED TIME',
      width: 170,
      flex: 1,
    },
    {
      field: 'activityType',
      headerName: 'ACTIVITY TYPE',
      width: 220,
      flex: 1,
    },
    {
      field: 'requestedon',
      headerName: 'REQUESTED ON',
      width: 170,
      flex: 1,
    },
    {
      field: 'agentcomment',
      headerName: 'AGENT COMMENT',
      width: 180,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'STATUS',
      width: 150,
      flex: 1,
    },
    {
      field: 'reviewdby',
      headerName: 'REVIEWED BY',
      width: 150,
      flex: 1,
    },
  ];
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  /**
   *
   * @example - noDataFound()
   */
  const noRequestFound = () => {
    return (
      <CcfBox className={styles.tableDataContainer}>
        <CcfBox className={styles.noDataFoundBlock}>
          <CcfNoRequestFoundIcon style={{ fontSize: 240 }} />
          <CcfTypography className={styles.noRequestTxt}>
            No request was created yet
          </CcfTypography>
        </CcfBox>
      </CcfBox>
    );
  };

  /**
   *
   * @example - handleTabChange()
   */
  const handleTabChange = (tabIndex: any) => {
    setSelectedTabIndex(tabIndex);
  };

  return (
    <CcfBox className={styles.wemScheduleContainer}>
      <CcfBox>
        <CcfTypography className={styles.wemTabTitle}>
          Schedule Requests
        </CcfTypography>
      </CcfBox>
      <CcfBox className={styles.tabSection}>
        <CcfBox
          className={`${styles.tabs} ${
            selectedTabIndex === 0 ? styles.selectedTab : ''
          }`}
          onClick={() => handleTabChange(0)}
        >
          Shift Trade Requests
        </CcfBox>
        <CcfBox
          className={`${styles.tabs} ${
            selectedTabIndex === 1 ? styles.selectedTab : ''
          }`}
          style={{
            borderRight: selectedTabIndex === 0 ? '1px solid #dae2e8' : 'none',
          }}
          onClick={() => handleTabChange(1)}
        >
          Activity Requests
        </CcfBox>
      </CcfBox>
      <CcfWemTable
        columns={
          selectedTabIndex === 0 ? shiftTradeTypeColumns : activityTypeColumns
        }
        tableHeaderText="0 Requests"
        noDataFound={noRequestFound()}
      />
    </CcfBox>
  );
}
